import { nextTick } from 'vue'

const findErrorElement = (): Element | null => {
  // Only search in the currently visible tab (the one without 'hidden' class)
  const scrollContainer = document.querySelector('.max-h-\\[calc\\(100vh-10rem\\)\\]')
  const innerContainer = scrollContainer?.querySelector('.overflow-y-auto')
  
  if (innerContainer) {
    // Find the visible tab (div without 'hidden' class)
    const visibleTab = innerContainer.querySelector(':scope > div:not(.hidden)')
    if (visibleTab) {
      const errorElement = visibleTab.querySelector('.n-form-item-feedback--error')
      if (errorElement) {
        const parentFormItem = errorElement.closest('.n-form-item')
        return parentFormItem || errorElement
      }
    }
  }

  // Fallback to searching entire document
  const errorElement = document.querySelector('.n-form-item-feedback--error')
  if (errorElement) {
    const parentFormItem = errorElement.closest('.n-form-item')
    return parentFormItem || errorElement
  }
  return null
}


/**
 * Scrolls an element into view, handling nested scroll containers
 * @param element - The element to scroll to
 */
const scrollElementIntoView = (element: Element): void => {
  // Find the scrollable parent container
  const scrollContainer = document.querySelector(
    '.max-h-\\[calc\\(100vh-10rem\\)\\]'
  )

  if (scrollContainer) {
    // Get element position relative to scroll container
    const containerRect = scrollContainer.getBoundingClientRect()
    const elementRect = element.getBoundingClientRect()

    // Calculate scroll position to bring element to top of visible area (with some padding)
    const scrollTop =
      scrollContainer.scrollTop + (elementRect.top - containerRect.top) - 20

    // Only scroll if element is not fully visible
    const isFullyVisible =
      elementRect.top >= containerRect.top &&
      elementRect.bottom <= containerRect.bottom

    if (!isFullyVisible) {
      scrollContainer.scrollTo({
        top: Math.max(0, scrollTop),
        behavior: 'smooth',
      })
    }
  } else {
    // Fallback to standard scrollIntoView
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
  }

  // Also try to focus the element if it's focusable
  if (element instanceof HTMLElement) {
    const focusable = element.querySelector(
      'input, select, textarea, button, [tabindex]'
    ) as HTMLElement
    if (focusable) {
      setTimeout(() => focusable.focus(), 100)
    }
  }
}

/**
 * Scrolls to the first error element in the form
 */
export const scrollToValidationError = async (): Promise<void> => {
  await nextTick()

  // First attempt after short delay
  setTimeout(() => {
    const errorElement = findErrorElement()

    if (errorElement) {
      scrollElementIntoView(errorElement)
      return
    }

    // Retry after longer delay if first attempt failed
    setTimeout(() => {
      const retryElement = findErrorElement()
      if (retryElement) {
        scrollElementIntoView(retryElement)
      }
    }, 300)
  }, 150)
}


